'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  FORM_FLOATING_ALERT: 'form-floating-alert',
  FORM_FLOATING_ALERT_CLOSE_BUTTON: 'form-floating-alert-close-button',
  FORM_FLOATING_ALERT_ERROR: 'form-floating-alert-error',
  FORM_FLOATING_ALERT_WRAPPER: 'form-floating-alert-wrapper',
  FORM_FLOATING_ALERT_WRAPPER_OPENED: 'form-floating-alert-wrapper--opened',
  FORM_INPUT_ERROR: 'form-input-error',
  FORM_INPUT_VALIDATION_MESSAGE: 'form-input-validation-message',
  FORM_INPUT_VALIDATION_MESSAGE_ERROR: 'form-input-validation-message-error'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/constants/css-classes.js
// module id = 3
// module chunks = 0 1 2 3